import { createContext, useContext, useCallback, useState, useRef } from "react";
import NoticePopup from "./NoticeBox";

const NotificationContext = createContext();

export function NoticeProvider({children}) {
    const [Notices, SetNotices] = useState([])
    const timers = useRef({});
    const NoticeDuration = 10000;
    const removeNotice = useCallback((id) => {
        clearTimeout(timers.current[id]);
        delete timers.current[id];
        SetNotices((prev) => prev.filter((n) => n.id !== id));
    }, []);

    const addNotice = useCallback((title = "Default Title", message = "No Message Provided, Have a Good Day", type = "Info") => {
        const id = Date.now();
        SetNotices((prev) => [...prev, {id, title, message, type}]);

        timers.current[id] = setTimeout(() => {
            removeNotice(id);
        }, NoticeDuration);
    }, [removeNotice]);

    const handleNoticeHover = (id) => {
        clearTimeout(timers.current[id])
    };

    const handleNoticeUnhover = (id) => {
        timers.current[id] = setTimeout(() => {
            removeNotice(id);
        }, NoticeDuration)
    }
    
    return (
        <NotificationContext.Provider value={addNotice}>
            {children}
            <div className="NoticeArea">
                {
                    Notices.map((notice, index) => (
                        <NoticePopup
                        Id={notice.id}
                        Title={notice.title}
                        NoticeType={notice.type}
                        OnExit={() => removeNotice(notice.id)}
                        OnHover={() => handleNoticeHover(notice.id)}
                        OnUnhover={() => handleNoticeUnhover(notice.id)}
                        >
                            {notice.message}
                        </NoticePopup>
                    ))
                }
            </div>
        </NotificationContext.Provider>
    );
}

export function useNotification() {
  return useContext(NotificationContext);
}